import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConnectionService } from '../../_services';
import { environment } from "../../../environments/environment";
@Component({
  selector: 'app-automationsummery',
  templateUrl: './automationsummery.component.html',
  styleUrls: ['./automationsummery.component.less']
})
export class AutomationsummeryComponent implements OnInit {
  auid: string;
  AutomationSummery = null;
  url: string;
  uId: string = '';
  constructor(
    private connectionservice: ConnectionService,
    private route: ActivatedRoute,
    private router: Router,) { }

  ngOnInit(): void {
    this.url = environment.logoURL;

   
    try {
      this.route.firstChild.params.subscribe(params => {
        //let auid = +params['auid'];
        this.auid = params['auid'];
      });
    } catch (e) {
      this.auid = this.route.snapshot.params['auid'];
    }
    if (this.auid) {
      this.connectionservice.getAutomationSummeryDetail(this.auid)
        .pipe(first())
        .subscribe(
          AutomationSummery => {
            this.AutomationSummery = AutomationSummery;



          });
    }

  }

}
